/*
 * Badeloft cart resync safety net — 2026-08-29 (v3).
 *
 * Root cause of the delete bug is fixed in component-cart-items.js (lines are
 * addressed by key, mutations run in sequence). This layer only handles the
 * case where the rendered rows disagree with the real cart after the update
 * queue has drained — e.g. another tab changed the same cart.
 *
 * Recovery is in-place: dispatch cart:update with no sections, which makes the
 * component re-render its section from the server without a navigation (no
 * page transition, no scroll jump, nothing to blank). Only if the view is
 * still wrong afterwards do we reload, and that reload skips the theme's
 * cross-document view transition. One hard reload per 10s max.
 */
(function () {
  var RELOAD_KEY = 'bfCartResyncAt';
  var RELOAD_COOLDOWN = 10000;
  var softAttempts = 0;

  document.addEventListener('bf:cart-settled', function () {
    softAttempts = 0;
    setTimeout(verify, 450);
  });

  function cartUrl() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root.replace(/\/$/, '') + '/cart.js';
  }

  function recentlyReloaded() {
    try {
      var last = parseInt(sessionStorage.getItem(RELOAD_KEY) || '0', 10);
      return last && Date.now() - last < RELOAD_COOLDOWN;
    } catch (error) {
      return false;
    }
  }

  function hardReload() {
    if (recentlyReloaded()) return;
    try {
      sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch (error) {
      /* private mode */
    }
    // Skip the cross-document view transition for this navigation.
    window.addEventListener(
      'pageswap',
      function (event) {
        if (event.viewTransition) event.viewTransition.skipTransition();
      },
      { once: true }
    );
    window.location.reload();
  }

  function verify() {
    var component = document.querySelector('cart-items-component');
    if (!component || component.hasAttribute('data-bf-busy')) return;
    if (component.querySelector('.removing')) {
      setTimeout(verify, 400);
      return;
    }
    var body = component.querySelector('tbody');

    fetch(cartUrl(), { cache: 'no-store' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        if (component.hasAttribute('data-bf-busy')) return;
        var rendered = body ? body.children.length : 0;
        if (rendered === cart.items.length) return;

        if (softAttempts < 2) {
          softAttempts += 1;
          // In-place re-render of the cart section from the server.
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: {} } }));
          setTimeout(verify, 1500);
          return;
        }
        hardReload();
      })
      .catch(function () {});
  }
})();
